import { mainColor, UNIT } from '../../constants/theme';

const platform = require('platform');

const info = platform.parse(navigator.userAgent);
export const styles = () => ({
  cardContent: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    position: 'relative',
    height: '64%'
  },

  progress: {
    margin: UNIT * 5,
    textAlign: 'center',
    color: mainColor.secondaryColor
  },
  icon: {
    fontSize: UNIT,
    backgroundColor: 'transparent',
    color: mainColor.colorWhite
  },
  text: {
    color: mainColor.colorBlack
  },
  orderText: {
    fontSize: UNIT * 1.5,
    fontWeight: 'bolder',
    color: mainColor.colorBlack
  },
  arroundIcon: {
    display: 'flex',
    padding: 3,
    backgroundColor: 'white',
    justifyContent: 'center',
    left: UNIT,
    zIndex: 1,
    width: UNIT * 2.1875,
    height: UNIT * 2.1875,
    position: 'relative',
    borderRadius: UNIT * 1.25
  },
  textTitle: {
    fontWeight: 'bold',
    width: '100%',
    overflow: 'hidden',
    textAlign: 'center',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },

  descriptionStyle: {
    fontSize: UNIT * 1,
    marginTop: 0,
    width: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    right: 0,
    bottom: 0
  },

  card: {
    height: UNIT * 9.375,
    width: UNIT * 11.71875,
    display: 'flex',
    justifyContent: 'center'
  },
  total: {
    padding: UNIT * 0.5,
    borderRadius: UNIT * 1.875,
    backgroundColor: 'white',
    fontWeight: 'bold'
  },
  header: {
    display: 'flex',
    height: '24%',
    borderTopLeftRadius: UNIT * 1.5,
    borderTopRightRadius: UNIT * 1.5,
    padding: '0 20px 0 20px',
    justifyContent: 'center',
    alignItems: 'center'
  },
  footer: {
    display: 'flex',
    listStyle: 'none',
    height: '24%',
    borderBottomLeftRadius: UNIT * 1.5,
    borderBottomRightRadius: UNIT * 1.5,
    backgroundImage: 'linear-gradient(to right, #e7e2e2 0%, #e7e2e2 50%, transparent 50%)',
    backgroundSize: '13px 1px',
    backgroundRepeat: 'repeat-x',
    padding: '10px 30px 10px 15px',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  hrStyle: {
    border: '0',
    height: '2px',
    backgroundColor: mainColor.secondaryColor,
    width: UNIT * 1.875
  },
  progressBar: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  img: {
    width: UNIT * 0.8125,
    marginRight: UNIT * 0.3125,
    objectFit: 'contain'
  },
  clockIcon: {
    width: UNIT * 1.4375,
    marginRight: UNIT * 0.625,
    objectFit: 'contain'
  },
  paper: {
    backgroundColor: mainColor.colorWhite,
    height: info.name === 'Safari' && parseInt(info.version, 10) < 15 && UNIT * 18,
    width: '100%',
    aspectRatio: 1 / 1,
    zIndex: 1,
    top: 0,
    boxShadow: '0 1px 5px rgba(0,0,0,0.1), 0 0 50px rgba(0,0,0,0) inset',
    display: 'flex',
    flexDirection: 'column'
  },
  mediaStyle: { fontSize: UNIT * 0.5, color: mainColor.colorDarkGray, fontWeight: 'bold' },
  totalText: {
    fontWeight: 'bold'
  },
  orderRow: {
    fontSize: UNIT * 0.9375,
    flexShrink: 0,
    padding: UNIT * 1.0625,
    cursor: 'pointer',
    textAlign: 'center',
    color: 'black'
  },
  canalImage: { width: UNIT * 4.375, height: UNIT * 2.5 },
  remainingTime: {
    display: 'block',
    fontSize: UNIT * 0.875
  },
  deliveryIcon: {
    marginBottom: UNIT * 0.35,
    fontSize: UNIT * 1.125
  },
  paidIcon: {
    marginRight: `${UNIT * 0.8125}px!important`
  }
});
